import { NotAllowed, UnhandledError } from '@web/common';
import { BaseGuards } from '../guard';
import { ExtendedRoute } from './routes.model';

export const BaseRoutes: Record<string, ExtendedRoute> = {
  liveI18N: {
    path: 'liveI18N',
    pathMatch: 'full',
    canActivate: [BaseGuards.liveI18NModeGuardFn],
    component: {} as any,
  },
  unhandledError: { path: 'unhandled-error', component: UnhandledError },
  notAllowed: { path: 'not-allowed', component: NotAllowed },
};
